import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-sentence-checker',
  templateUrl: './sentence-checker.component.html',
  styleUrls: ['./sentence-checker.component.scss']
})
export class SentenceCheckerComponent implements  OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle("免費線上句子檢查工具——Trinka AI");
    this.metaTagService.updateTag({ name: 'description', content: "免費線上句子檢查工具——檢查您的句子結構和措辭是否正確。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "免費線上句子檢查工具——Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "免費線上句子檢查工具——檢查您的句子結構和措辭是否正確。" });    
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/sentence-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/tw/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/sentence-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/sentence-checker' });
  }
}
